import { observer } from 'mobx-react-lite';

import { MobileScreen } from 'components/MobileScreen';
import { useStore } from 'hooks/useStore';

import { Content } from '../Content';

const Mobile = () => {
  const {
    app: { i18n },
    filter: { resetDimensions, isDimensionsDefault },
  } = useStore();

  const actions = {
    second: {
      onClick: resetDimensions,
      text: i18n.common.reset,
    },
  };

  return (
    <MobileScreen hasBackButton actions={isDimensionsDefault ? undefined : actions} title={i18n.dimensions.label}>
      <Content />
    </MobileScreen>
  );
};

const connected = observer(Mobile);

export { connected as Mobile };
